/* eslint-disable @typescript-eslint/no-unused-vars */
import { useDispatch, useSelector } from 'react-redux';

import { updateUserpicStart } from 'modules/auth/authSlice';
import { authStorage } from 'modules/auth/authStorage';

import { deleteFile, uploadFile } from 'services/file/fileService';
import { FileType } from 'services/file/types';

import { InviteSagaPayload, UpdateMemberRequestValues } from './userApiTypes';
import {
  deleteUserStart,
  getMembersStart,
  getUserState,
  inviteUserStart,
  updateMemberStart,
} from './userSlice';

export const useUser = () => {
  const dispatch = useDispatch();
  const state = useSelector(getUserState);

  function inviteUser({ emails, role, agencies, currentAgencyId }: InviteSagaPayload) {
    dispatch(
      inviteUserStart({
        emails,
        role,
        agencies,
        currentAgencyId,
      }),
    );
  }

  function updateMember(payload: UpdateMemberRequestValues) {
    dispatch(updateMemberStart(payload));
  }

  function deleteUser(subId: string, agencyId: string | null) {
    dispatch(deleteUserStart({ subId, agencyId }));
  }

  function getMembers(agencyId: string | null, email: string) {
    dispatch(getMembersStart({ page: 0, size: 10000, agencyId: agencyId, email: email }));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async function uploadUserpic(file: any) {
    const user = await authStorage.getUser();

    const response = await uploadFile(file, FileType.PROFILE, user?.id || '');

    dispatch(updateUserpicStart(response.url));
  }

  async function deleteUserpic() {
    const user = await authStorage.getUser();

    await deleteFile(FileType.PROFILE, user?.id || '');
    dispatch(updateUserpicStart(''));
  }

  const isInvited = state.isInvited;
  const members = state.members;
  const errorText = state.error;

  return {
    getMembers,
    uploadUserpic,
    deleteUserpic,
    inviteUser,
    deleteUser,
    updateMember,
    members,
    isInvited,
    errorText,
  };
};
